<script>
import { mapState } from 'vuex';
import { CONTEXT } from '@/const';

const BANNER_CLOSE_TIME = 'banner-close-time';

export default {
  name: 'CookieBanner',
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState(['cookieStatement']),
  },
  watch: {
    cookieStatement(value) {
      this.visible = value.visible;
      this.setVisible();
    },
  },
  methods: {
    setVisible() {
      const closeTime = localStorage.getItem(BANNER_CLOSE_TIME);
      if (!closeTime) {
        return;
      }
      const sevenDays = 7 * 24 * 60 * 60 * 1000;
      if (Date.now() < parseInt(closeTime) + sevenDays) {
        this.visible = false;
      }
    },
    forwardCookiesStatement() {
      window.open(`${CONTEXT.uniportal}/cookie-statements.html`, '_blank');
    },
    closeBanner() {
      localStorage.setItem(BANNER_CLOSE_TIME, Date.now());
    },
  },
};
</script>

<template>
  <el-alert
    v-if="visible"
    type="info"
    show-icon
    class="cookie-banner cookie-banner-pc cookie-banner-mobile"
    @close="closeBanner"
  >
    <template #title>
      <div class="cookie-banner-content">
        <span class="cookie-banner-text">{{ $t('cookieBannerText') }}</span>
        <span class="cookie-banner-more" @click="forwardCookiesStatement">
          {{ $t('learnMore') }}
        </span>
      </div>
    </template>
  </el-alert>
</template>

<style scoped lang="less">
.cookie-banner {
  position: fixed;
  color: #191919 !important;

  ::v-deep .el-alert {
    &__content {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 0;
    }

    &__title {
      flex: 1;
    }

    &__icon.el-icon-info {
      color: #2070f3;
    }

    &__closebtn.el-icon-close {
      position: unset;
      color: #191919;

      &::before {
        display: block;
        height: 12px;
      }
    }
  }

  &-content {
    line-height: 22px;
  }

  &-more {
    color: #0067d1;
    cursor: pointer;
  }

  @media screen and (min-width: 640px) {
    &-pc {
      padding: 19px 64px;
      bottom: 0;
      background-color: #eef3fe !important;

      .cookie-banner-more {
        margin-left: 16px;
      }

      ::v-deep .el-alert {
        &__title {
          padding-right: 16px;
        }
      }
    }
  }
  @media screen and (max-width: 640px) {
    &-mobile {
      width: auto;
      padding: 10px 13px 10px 12px;
      left: 12px;
      right: 12px;
      border-radius: 16px;
      background-color: #f3f3f3;
      bottom: 12px;

      ::v-deep .el-alert {
        &__title {
          padding-right: 16px;
        }
      }
    }
  }
}
</style>
